module.exports = __webpack_public_path__ + "img/cari_tr.d774c9de.svg";